import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from 'src/app/core/utils/utils';
import * as _ from 'lodash';
import { PETICIONES } from 'src/app/core/utils/constants';
import { DialogsAlertComponent } from '../dialogs-alert/dialogs-alert.component';
import { Mail } from 'src/app/core/entities/mail.model';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';


@Injectable()
export class DialogsSendMailsService {

    mail: Mail = new Mail();
    loginInterno: any;

    constructor(private https: HttpClient,
                private translateService: TranslateService,
                private dialog: MatDialog) { }

    init() {}    

    /**
    * @description
    * Deshabilita o habilita el botón aceptar
    */
    deshabilitar() {
        if ((Utils.noUndfAndNull(this.mail.emisor) && this.mail.emisor!== "") && 
            (Utils.noUndfAndNull(this.mail.asunto) && this.mail.asunto!== "") &&
            (Utils.noUndfAndNull(this.mail.cuerpo) && this.mail.cuerpo!== "")) {
            return false;
        } else {
            return true;
        }
    }

    /**
    * @description
    * Abre un cuadro de dialogo para informar de un error
    * @param error Texto a mostrar
    */
    public errorCargaWS(error: string) {
            const dialogRef = this.dialog.open(DialogsAlertComponent, {
            disableClose: true,
            hasBackdrop: true,
            data: { texto: this.translateService.instant(error) }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }

    public pushFileToStorage(formData: FormData, header?: HttpHeaders): Observable<HttpEvent<string>> {
        const headers = (header == undefined || header == null) ? new HttpHeaders().set('Content-Type', 'multipart/form-data') : header;
        return this.https.post<string>(PETICIONES.webservice.doPostArchivo, formData, {
            headers: headers,
            reportProgress: true,
            observe: 'events'
        });
    }

    build() {
        this.mail = new Mail();
    }
}
